import { Component, HostListener, Input } from '@angular/core';
import { IGenericModal } from '@interfaces/genericModal.interface';
import { IonIcon } from "@ionic/angular/standalone";

@Component({
    selector: 'app-generic-modal-salir-pagina',
    templateUrl: './generic-modal-salir-pagina.component.html',
    styleUrls: ['./generic-modal-salir-pagina.component.scss'],
    imports: [IonIcon, ],
    standalone: true
})
export class GenericModalSalirPaginaComponent {
    @Input() data?: IGenericModal;

    @HostListener('document:keydown.escape', ['$event'])
    handleEscape(event: Event) {
        event.preventDefault();
        this.data?.closeButtonCallback?.();
    }
}
